import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
   selector: 'app-confirm-dialog',
   templateUrl: './confirm-dialog.html',
   styleUrls: ['./confirm-dialog.scss']
})
export class ConfirmDialogComponent {

   public title: string;
   public message: string[];
   public showCancelButton: boolean;
   public cancelButtonText: string;
   public okButtonText: string;

   constructor(
      public dialogRef: MatDialogRef<ConfirmDialogComponent>
   ) {

   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/confirm-dialog/confirm-dialog.ts